import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'; // Correção para usar o adaptador da v3
import { ptBR } from 'date-fns/locale';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Suppress ResizeObserver loop limit exceeded error
const resizeObserverLoopErr = 'ResizeObserver loop completed with undelivered notifications.';
const ethereumErr = 'window.ethereum'; // Suppress Brave/Wallet injection errors

const originalError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string') {
    if (args[0].includes(resizeObserverLoopErr) || args[0].includes(ethereumErr)) {
      return;
    }
  }
  originalError(...args);
};

// Also catch uncaught exceptions to prevent white screen crashes for this specific issue
window.addEventListener('error', (event) => {
  if (event.message && (event.message.includes('window.ethereum') || event.message.includes('selectedAddress'))) {
    event.stopImmediatePropagation();
    event.preventDefault(); // Prevent crash
    console.warn('Suprimindo erro de injeção de carteira (Brave/MetaMask).');
  }
});

root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
      <App />
    </LocalizationProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();